import { DataGridActiveColumns } from '@virtus/components/DataGrid/models';

export const UserDetailsActiveColumns: DataGridActiveColumns = {
  UserName: true,
  PartitionKey: true,
  TimeStamp: true,
  LoginLocation: false,
  GatewayIp: true,
  LocalIp: true,
  IsValidUser: true,
  UserSamAccount: true,
};

export const UserDetailsBaseColumns = {
  TimeStamp: {
    field: 'TimeStamp',
    filterPlaceholder: 'Search TimeStamp',
    width: 240,
    template: 'DateTimeTpl',
    Filter: 'DateFilter',
  },
  UserName: {
    field: 'User Name',
    filterPlaceholder: 'Search User Name',
    width: 200,
  },
  UserSamAccount: {
    field: 'User Sam Account',
    filterPlaceholder: 'Search User Sam Account',
    width: 200,
  },
  GatewayIp: {
    field: 'GatewayIp',
    filterPlaceholder: 'Search Gateway IP',
    width: 130,
  },
  LocalIp: {
    field: 'LocalIp',
    filterPlaceholder: 'Search Local IP',
    width: 130,
  },
  PartitionKey: {
    field: 'Application Name',
    filterPlaceholder: 'Search Application Name',
    width: 200,
  },
  IsValidUser: {
    field: 'Is Nexus user',
    filterPlaceholder: 'Search Is Nexus User',
    width: 170,
    template: 'BoolTpl',
  },
  LoginLocation: {
    field: 'Login Location',
    filterPlaceholder: 'Search Login Location',
    width: 200,
  },
};

export const UserDetailHeaders = [
  {
    caption: 'TimeStamp', 
    allowFiltering: true, 
    alignment: 'left', 
    dataField: 'TimeStamp', 
    dataType: 'datetime', 
    width: '40%',
  },
  {
    caption: 'User Name', 
    allowFiltering: true, 
    alignment: 'left', 
    dataField: 'UserName', 
    dataType: 'string',
    width: '40%',
  },
  {
    caption: 'User Sam Account', 
    allowFiltering: true, 
    alignment: 'left', 
    dataField: 'UserSamAccount', 
    dataType: 'string',
    width: '20%',
  },
  {
    caption: 'Gateway IP', 
    allowFiltering: true, 
    alignment: 'left', 
    dataField: 'GatewayIp', 
    dataType: 'string',    
    width: '20%',
  },
  {
    caption: 'Local IP', 
    allowFiltering: true, 
    alignment: 'left', 
    dataField: 'LocalIp', 
    dataType: 'string',    
    width: '20%',
  },
  {
    caption: 'Application Name', 
    allowFiltering: true, 
    alignment: 'left', 
    dataField: 'PartitionKey', 
    dataType: 'string',    
    width: '40%',
  },
  {
    caption: 'Is Nexus User', 
    allowFiltering: true, 
    alignment: 'left', 
    dataField: 'IsValidUser', 
    dataType: 'boolean',    
    width: '20%',
  }
];